import { render, staticRenderFns } from "./discount-list.vue?vue&type=template&id=43d91899&"
import script from "./discount-list.vue?vue&type=script&lang=js&"
export * from "./discount-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports